






















































































































































































import SelectMasterType from "@/components/custom/select/SelectMasterType.vue";
import { DisplayBoolean } from "@/components/DisplayBoolean";
import {
  useFindMasterType,
  useLeasing,
  useMapMasterTypeToOptionAlt,
} from "@/hooks";
import MNotificationVue from "@/mixins/MNotification.vue";
import { Option } from "@/models/class/option.class";
import { CREATE_LEASING_ACCOUNT_PAYABLES_ROUTE } from "@/models/constant/routes/accountpayables.constant";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { LeasingStateEnum } from "@/models/enums/Leasing.enum";
import { PaymentRealizationCreateDto } from "@/models/interface/leasing";
import { initRowPeriod } from "@/store/account-payable/leasing/resource";
import {
  FORM_MODE,
  FormValue,
  RowPeriod,
  State,
} from "@/store/account-payable/leasing/types";
import {
  formatterNumber,
  reverseFormatNumber,
} from "@/validator/globalvalidator";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapActions, mapMutations, mapState } from "vuex";

@Component({
  components: {
    SelectMasterType,
    DisplayBoolean,
  },
  computed: {
    ...mapState({
      store: (st: any) => st.leasingStore,
      storeBaseDecimalPlace: (st: any) =>
        st.preferenceStore.baseDecimalPlace as number,
    }),
  },
  methods: {
    ...mapMutations({
      setForm: "leasingStore/setForm",
    }),
    ...mapActions({
      generatePeriod: "leasingStore/generatePeriod",
      fetchDetail: "leasingStore/fetchDetail",
    }),
  },
})
export default class FormPayment extends Mixins(MNotificationVue) {
  @Prop({ required: true, type: String, default: "" })
  mode!: string;

  @Prop({ required: false, type: Array, default: () => [] })
  selectedAssets!: string[];

  DEFAULT_DATE_FORMAT = DEFAULT_DATE_FORMAT;
  FORM_MODE = FORM_MODE;
  reverseFormatNumber = reverseFormatNumber;
  formatterNumber = formatterNumber;

  storeBaseDecimalPlace!: number;
  store!: State;
  generatePeriod!: () => void;
  fetchDetail!: (leasingId: string) => Promise<void>;
  setForm!: (value: Partial<FormValue>) => void;
  paymentTypeOptions: Option[] = [];

  columns = [
    {
      title: this.$t("lbl_billing_period"),
      dataIndex: "installment",
      fixed: "left",
      width: "150px",
      scopedSlots: { customRender: "installment" },
    },
    {
      title: this.$t("lbl_payment_number"),
      dataIndex: "chequeNumber",
      fixed: "left",
      width: "200px",
      scopedSlots: { customRender: "chequeNumber" },
    },
    {
      title: this.$t("lbl_payment_type"),
      dataIndex: "paymentType",
      scopedSlots: { customRender: "paymentType" },
    },
    {
      title: this.$t("lbl_payment_date"),
      dataIndex: "paymentDate",
      scopedSlots: { customRender: "paymentDate" },
    },
    {
      title: this.$t("lbl_principal_cost"),
      dataIndex: "principalCost",
      scopedSlots: { customRender: "principalCost" },
    },
    {
      title: this.$t("lbl_interest_cost"),
      dataIndex: "interestCost",
      scopedSlots: { customRender: "interestCost" },
    },
    {
      title: this.$t("lbl_installment"),
      dataIndex: "paymentCost",
      scopedSlots: { customRender: "currency" },
    },
    {
      title: this.$t("lbl_balance"),
      dataIndex: "balance",
      scopedSlots: { customRender: "currency" },
    },
    {
      title: this.$t("lbl_notes"),
      dataIndex: "notes",
      scopedSlots: { customRender: "notes" },
    },
    {
      title: this.$t("lbl_realization"),
      dataIndex: "paymentRealizationDate",
      scopedSlots: { customRender: "paymentRealizationDate" },
    },
    {
      title: this.$t("lbl_document_reference"),
      dataIndex: "cashInOutDocumentNumber",
      scopedSlots: { customRender: "cashInOutDocumentNumber" },
    },
    {
      key: "operation",
      align: "center",
      scopedSlots: { customRender: "operation" },
    },
  ];

  calcPaymentAndBalance(row: RowPeriod): void {
    const { calcPaymentCost, calcPaymentFirstBalance, calcPaymentBalance } =
      useLeasing();
    const FIRST_PERIOD = 1;

    row.paymentCost = calcPaymentCost({
      principalCost: row.principalCost,
      interestCost: row.interestCost,
    });

    let prevBalance = 0;
    const currentIdx: number = this.store.form.periodList.findIndex(
      e =>
        e.installment === row.installment &&
        e.subInstallment === row.subInstallment
    );
    if (currentIdx > 0) {
      prevBalance = this.store.form.periodList[currentIdx - 1].balance;
    }

    row.balance = calcPaymentBalance({
      prevBalance,
      paymentCost: row.paymentCost,
    });

    if (row.installment === FIRST_PERIOD && row.subInstallment === 0) {
      row.balance = calcPaymentFirstBalance({
        paymentCost: row.paymentCost,
        totalInstallment: this.store.form.total,
      });
    }
  }

  handleCancelPayment(row: RowPeriod): void {
    const { cancelPayment } = useLeasing();
    row.loading.cancel = true;
    cancelPayment(row.id)
      .then(({ documentNo }) => {
        this.showNotifSuccess("notif_cancel_success", {
          documentNumber: documentNo,
        });
        this.fetchDetail(this.store.form.id);
      })
      .catch(error => {
        this.showNotifError(
          error?.response?.data?.details?.[0] ?? "notif_process_fail"
        );
      })
      .finally(() => {
        row.loading.cancel = false;
      });
  }

  handleCreatePayment(row: RowPeriod): void {
    const { settlePayment, mapPeriodLineToSettlePaymentDto } = useLeasing();
    const req: PaymentRealizationCreateDto = mapPeriodLineToSettlePaymentDto(
      row,
      this.selectedAssets
    );
    row.loading.settle = true;
    settlePayment(row.id, req)
      .then(({ documentNo }) => {
        this.showNotifSuccess("notif_create_success", {
          documentNumber: documentNo,
        });
        return this.fetchDetail(this.store.form.id);
      })
      .catch(error => {
        this.showNotifError(
          error?.response?.data?.details?.[0] ?? "notif_process_fail"
        );
      })
      .finally(() => {
        row.loading.settle = false;
      });
  }

  isAllowCreatePayment(row: RowPeriod): boolean {
    const { status } = this.store.form;
    const havntPaid = !row.cashInOutId;
    return (
      havntPaid &&
      status.toUpperCase() === LeasingStateEnum.SUBMITTED.toUpperCase()
    );
  }

  isLastInstallmentWithDocumentNumber(row: RowPeriod): boolean {
    if (row.subInstallment !== 0) return false;

    const lastInstallmentWithDocumentNumber = this.store.form.periodList.reduce(
      (max, period) =>
        period.subInstallment === 0 && period.cashInOutDocumentNumber
          ? Math.max(max, period.installment)
          : max,
      0
    );

    return (
      !!row.cashInOutDocumentNumber &&
      row.installment === lastInstallmentWithDocumentNumber
    );
  }

  showAddRow(row: RowPeriod): boolean {
    return (
      this.mode == FORM_MODE.EARLY_SETTLEMENT &&
      this.isLastInstallmentWithDocumentNumber(row) &&
      this.$ability.can("create", "payment-leasing")
    );
  }

  canAddRow(row: RowPeriod): boolean {
    return this.showAddRow(row) && this.selectedAssets.length > 0;
  }

  formatInstallmentLabel(row: RowPeriod): string {
    const { formatInstallmentLabel } = useLeasing();
    return formatInstallmentLabel(row);
  }

  handleAddRow(parent: RowPeriod): void {
    const child: RowPeriod = initRowPeriod();
    child.installment = parent.installment;

    const siblings = this.store.form.periodList.filter(
      period => period.installment === parent.installment
    );
    const maxSubInstallment = siblings.reduce(
      (max, period) => Math.max(max, period.subInstallment),
      0
    );
    child.subInstallment = maxSubInstallment + 1;
    child.installmentLabel = `${parent.installment}.${child.subInstallment}`;
    child.parentId = parent.id;

    child.principalCost = 0;
    child.interestCost = 0;
    child.paymentType = parent.paymentType;

    const lastSiblingIndex = this.store.form.periodList.reduce(
      (lastIndex, period, index) =>
        period.installment === parent.installment ? index : lastIndex,
      -1
    );
    const periodList = [...this.store.form.periodList];
    periodList.splice(lastSiblingIndex + 1, 0, child);
    this.setForm({ periodList });

    this.calcPaymentAndBalance(child);
  }

  handleGenerate(): void {
    const form: Partial<FormValue> = {
      deletedPeriodLineIds: this.store.detail.periodList.map(row => row.id),
      periodList: [],
    };
    this.setForm(form);
    this.generatePeriod();
  }

  fetchPaymentType(): void {
    this.loading = true;
    useFindMasterType("LEASING_PAYMENT_TYPE")
      .then(res => {
        this.paymentTypeOptions = useMapMasterTypeToOptionAlt(res);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  isDisabledCreatePayment(row: RowPeriod): boolean {
    return (
      !!row.cashInOutId ||
      (this.mode === FORM_MODE.EARLY_SETTLEMENT && row.subInstallment === 0) ||
      (row.subInstallment > 0 && !row.id)
    );
  }

  isDisabledCancelPayment(row: RowPeriod): boolean {
    return (
      this.mode === FORM_MODE.EARLY_SETTLEMENT ||
      (!!row.cashInOutId && this.store.detail.isReclass) ||
      (this.store.detail.paidOff && this.store.detail.isReclass)
    );
  }

  editableMode(row: RowPeriod): boolean {
    return (
      (this.$route.name === CREATE_LEASING_ACCOUNT_PAYABLES_ROUTE.name ||
        this.mode === FORM_MODE.EARLY_SETTLEMENT) &&
      !row.cashInOutId
    );
  }

  mounted() {
    this.fetchPaymentType();
  }
}
